export default __webpack_public_path__ + "media/images/background-waves-6ab51254cbda0ac82b7b6d7bc5288385.svg";